import React, { useContext, useEffect } from 'react';
import { Redirect, Route, Link, useLocation } from 'react-router-dom';
import { Button, Paper, Typography } from '@material-ui/core';
import { firebaseAuth } from '../provider/AuthProvider';
import { rememberDestination } from '../routing/navigation';
import SessionStatus from './SessionStatus';

export function RequireAccess({ children, access = 'member' }) {
  const { currentUser, loading, sessionStatus, accessStatus, refreshAccess } = useContext(firebaseAuth);
  const location = useLocation();
  useEffect(() => {
    if (!currentUser && !loading && sessionStatus !== 'error') rememberDestination(location);
  }, [currentUser, loading, sessionStatus, location]);
  if (loading || sessionStatus === 'error') return <SessionStatus />;
  if (!currentUser) return <Redirect to={{ pathname: '/signin', state: { from: location } }} />;
  if (access === 'signedIn' || accessStatus === 'granted') return <>{children}</>;
  if (accessStatus === 'loading' || accessStatus === 'idle') return <Typography role="status" style={{ padding: 32 }}>Checking your lesson access…</Typography>;
  const failed = accessStatus === 'error';
  return <main style={{ maxWidth: 520, margin: '48px auto', padding: 20 }}><Paper style={{ padding: 28 }}>
    <Typography component="h1" variant="h5">{failed ? 'We couldn’t check your lesson access' : 'You’re signed in'}</Typography>
    <Typography role={failed ? 'alert' : undefined} style={{ margin: '20px 0' }}>{failed
      ? 'Your sign-in worked. Please check your connection and retry the access check.'
      : 'This account doesn’t currently have access to this lesson. Explore the learning plans, or contact office@21ifm.com if you’ve already purchased access.'}</Typography>
    {failed ? <Button onClick={refreshAccess} variant="contained" color="primary">Retry access check</Button>
      : <Button component={Link} to="/pricing" color="primary" variant="contained">Explore learning plans</Button>}
    <Button component={Link} to="/account" style={{ marginLeft: 12 }}>Your account</Button>
  </Paper></main>;
}

export default function ProtectedRoute({ component: Component, access, ...rest }) {
  return <Route {...rest} render={props => <RequireAccess access={access}><Component {...props} /></RequireAccess>} />;
}
